import { PaymentPlanType } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import {
  findPaymentScheduleEntryByType,
  getPaymentPlanTotalCost,
} from 'QuoteApp/utils/paymentPlan';

import { PaymentFrequencyCopy } from './types';

const paymentFrequencyCopy: PaymentFrequencyCopy = {
  weekly: {
    paymentPlanLabel: 'Weekly',
    futurePaymentFrequencyLabel: 'weekly',
  },
  bi_weekly: {
    paymentPlanLabel: 'Every two weeks',
    futurePaymentFrequencyLabel: 'every two weeks',
  },
  semi_monthly: {
    paymentPlanLabel: 'Twice a month',
    futurePaymentFrequencyLabel: 'twice a month',
  },
  monthly: {
    paymentPlanLabel: 'Monthly',
    futurePaymentFrequencyLabel: 'monthly',
  },
  full_pay: {
    paymentPlanLabel: 'Pay in full',
    futurePaymentFrequencyLabel: '',
  },
  in_full: {
    paymentPlanLabel: 'Pay in full',
    futurePaymentFrequencyLabel: '',
  },
};

export const getPaymentFrequencyCopy = (
  paymentFrequencyIdentifier: PaymentPlanType['paymentFrequencyIdentifier']
) => {
  const defaultCopy = {
    paymentPlanLabel: 'Payment plan',
    futurePaymentFrequencyLabel: 'monthly',
  };

  return paymentFrequencyCopy[paymentFrequencyIdentifier] ?? defaultCopy;
};

export const getDueTodayLabel = (paymentPlan: PaymentPlanType) => {
  const installmentEntry = findPaymentScheduleEntryByType(
    paymentPlan.paymentSchedule,
    'INSTALLMENT'
  );

  if (installmentEntry) {
    return `First payment`;
  }

  return '';
};

export const getPaymentPlanAmounts = (paymentPlan: PaymentPlanType) => {
  const downpaymentEntry = findPaymentScheduleEntryByType(
    paymentPlan.paymentSchedule,
    'DOWNPAYMENT'
  );

  const installmentEntry = findPaymentScheduleEntryByType(
    paymentPlan.paymentSchedule,
    'INSTALLMENT'
  );

  return {
    dueTodayAmount: downpaymentEntry?.amount ?? '',
    futurePaymentsAmount: installmentEntry?.amount ?? '',
    totalAmount: getPaymentPlanTotalCost(paymentPlan) ?? '',
  };
};
